/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import Model, { helper } from '@tripian/model';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import emptyImageData from '../../../../constant/emptyImage';
import ImgLazy from '../../../base/ImgLazy/ImgLazy';
import ShareIconButton from '../../../base/Button/Icons/ShareIconButton/ShareIconButton';
import FavoriteIconButton from '../../../base/Button/Icons/FavoriteIconButton/FavoriteIconButton';
import CloseIconButton from '../../../base/Button/Icons/CloseIconButton/CloseIconButton';
import SharePoiModal from '../../../SharePoiModal/SharePoiModal';
import classes from './PoiInfoImageMobile.scss';

interface IPoiInfoImageMobile {
  poi: Model.Poi;
  square: boolean;
  hideFavoriteIcon: boolean;
  favoriteLoading: boolean;
  favorite: boolean;
  toggleFavorite: (poi: Model.Poi, willFavorite: boolean) => void;
  close: (poi: Model.Poi) => void;
  t: (value: Model.TranslationKey) => string;
  stepType?: string;
}

const PoiInfoImageMobile: React.FC<IPoiInfoImageMobile> = ({ poi, square, hideFavoriteIcon, favorite, favoriteLoading, toggleFavorite, close, t, stepType }) => {
  const [showShareModal, setShowShareModal] = useState(false);

  const images = poi.gallery.length === 0 ? [{ url: emptyImageData, imageOwner: null }] : poi.gallery.map((img) => ({ url: stepType === 'activity' ? img.url : helper.imgUrl(img.url, 800), imageOwner: img.imageOwner }));

  return (
    <div className={classes.gallery}>
      <div className={classes.closeButton}>
        <CloseIconButton fill="#696969" clicked={() => close(poi)} />
      </div>
      <div className={classes.actions}>
        <ShareIconButton className={classes.shareIconButton} clicked={() => setShowShareModal(true)} />
        {!hideFavoriteIcon && (
          <FavoriteIconButton
            className={classes.favoriteIconButton}
            clicked={() => {
              toggleFavorite(poi, !favorite);
            }}
            loading={favoriteLoading}
            favorite={favorite}
          />
        )}
      </div>
      <Slider accessibility slidesToShow={1} slidesToScroll={1} infinite={false} speed={500} dots dotsClass="slick-dots slick-dots-bottom" arrows={false}>
        {images.map((img) => (
          <div className={classes.content} key={img.url}>
            <div className={square ? undefined : classes.img}>
              <ImgLazy objectFit={square ? 'cover' : 'contain'} key={img.url} src={img.url} alt="" x={800} y={800} />
            </div>
            {img.imageOwner && img.imageOwner.url && (
              <span className={classes.imageOwner}>
                <a rel="noopener noreferrer" target="_blank" href={`${img.imageOwner.url}`}>
                  © {t('trips.myTrips.itinerary.step.poi.photo')} {img.imageOwner?.title}
                </a>
              </span>
            )}
          </div>
        ))}
      </Slider>

      {showShareModal && <SharePoiModal poiName={poi.name} poiId={poi.id} onCancel={() => setShowShareModal(false)} t={t} />}
    </div>
  );
};

export default PoiInfoImageMobile;
